<!-- This card's html is very simple, however it may be added to later, so it's given its own component -->

<p-card class="equipment-card">
  {{equipment.fullTitle}}
  &nbsp;@if (deleteable) {
  <i class="pi pi-times" style="float:right; color:red; cursor: pointer;" (click)="deleteFromContainer()"></i>
}
<span class="clear"></span>
</p-card>